import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";

const Newsletter = () => {
  return (
    <div>
      <Container
        sx={{
          p: { xs: 2, md: 6 },
          my: 4,
          bgcolor: "#1F3E76",
          color: "#fff",
          borderRadius: 2,
        }}
      >
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography sx={{ fontSize: 24, mb: 2 }} variant="h3">
            Get early access today
          </Typography>
          <Typography
            sx={{ width: { xs: 1, md: "65%" }, mx: "auto" }}
            variant="body1"
          >
            It only takes between 1 minutes to 24h to be accepted. If you have
            any questions, our support team would be happy to help you.
          </Typography>
        </Box>
        <Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{ justifyContent: "center" }}
          >
            <input
              className="email-field"
              type="email"
              placeholder="email@example.com"
            />
            <Button
              sx={{
                borderRadius: 50,
                fontWeight: 500,
                textTransform: "inherit",
                color: "#fff",
              }}
              color="secondary"
              variant="contained"
            >
              Submit Request For Demo
            </Button>
          </Stack>
        </Box>
      </Container>
    </div>
  );
};

export default Newsletter;
